import TextBasedSectionContainer from '@/components/TextBasedSectionContainer'
import { PageSEO } from '@/components/SEO'
import Image from 'next/image'
import Link from 'next/link'
import SocialIcon from '@/components/social-icons'
import siteMetadata from '@/data/siteMetadata'

export default function About() {
  return (
    <>
      <PageSEO
        title={`Animerdle - About`}
        description={`About Animerdle`}
        keywords={'animerdle about'}
      />
      <TextBasedSectionContainer title={'About'}>
        <div className="container flex flex-col">
          <div className="flex flex-col sm:flex-row">
            <div className="text-center sm:w-1/3 sm:py-8 sm:pr-8">
              <Image
                src={'/static/images/animerdle.png'}
                alt="avatar"
                width="500"
                height="240"
                className="rounded-full"
              />
              <div className="mt-5 flex flex-col items-center justify-center text-center">
                <p className="prose dark:prose-dark">
                  Got any questions? Feel free to check out our <Link href="/faq">FAQ</Link>.
                </p>

                <div className="flex space-x-3 pt-6">
                  <SocialIcon kind="mail" href={`mailto:${siteMetadata.email}`} />
                  <SocialIcon kind="twitter" href={siteMetadata.twitter} />
                </div>
              </div>
            </div>
            <div className="prose mt-4 border-t border-gray-200 pt-4 text-center dark:prose-dark sm:mt-0 sm:w-2/3 sm:border-l sm:border-t-0 sm:py-8 sm:pl-8 sm:text-left">
              <h2>Meet Aria Nakamura, the Anime Enthusiast Behind Animerdle's Fun</h2>
              <p>
                Hey, anime pals! I’m Aria Nakamura, the one who developed Animerdle — a place where
                anime guessing games collide for a ton of fun.
              </p>
              <p>
                Animerdle’s main gig? Listen up to anime clips and guess which show they're from.
                Every day, we toss out a new clip, so you can flex your anime know-how and have a
                blast!
              </p>
              <p>
                And guess what? We're gearing up for more anime-inspired games and activities.
                Imagine a bunch of cool stuff that'll bring anime fans together for a good time.
              </p>
              <p>
                At Animerdle, we're all hardcore anime fans. We’re a small crew that's hyped about
                building a spot where everyone can geek out about their favorite shows and share the
                excitement.
              </p>
              <p>Catch you on the fun side,</p>
              <i>Aria Nakamura</i>
            </div>
          </div>
        </div>
      </TextBasedSectionContainer>
    </>
  )
}
